import { action, atom } from '@reatom/framework'

import type { ConfirmDialogProps } from '../confirm-dialog'
import type { TypeHelper } from '@blade/std-lib'

type ConfirmProps = TypeHelper.OmitKey<
  ConfirmDialogProps,
  'open' | 'onOpenChange'
>
export const activeConfirmDialogAtom = atom<ConfirmDialogProps | undefined>(
  undefined,
  'activeConfirmDialogAtom',
)

type ConfirmResult = { confirmed: boolean }
export const showConfirmDialogAction = action((ctx, props: ConfirmProps) => {
  const promise = new Promise<ConfirmResult>((resolve) => {
    const dialogProps: ConfirmDialogProps = {
      ...props,
      open: true,
      onConfirm: () => {
        resolve({ confirmed: true })
        activeConfirmDialogAtom(ctx, undefined)
      },
      onCancel: () => {
        resolve({ confirmed: false })
        activeConfirmDialogAtom(ctx, undefined)
      },
      onOpenChange: (open) => {
        if (!open) {
          resolve({ confirmed: false })
          activeConfirmDialogAtom(ctx, undefined)
        }
      },
    }
    activeConfirmDialogAtom(ctx, dialogProps)
  })

  return promise
}, 'showConfirmDialogAction')
